import { Factory } from 'miragejs';

const SCA_STATUS_ALLOW = 'allow';

export default Factory.extend({
  status: SCA_STATUS_ALLOW,
  counter: i => i + 1,
});
